const baseColorData = {};
export const ColorData = {
    fromJSON(object) {
        const message = Object.assign({}, baseColorData);
        message.background =
            object.background !== undefined && object.background !== null
                ? String(object.background)
                : undefined;
        message.foreground =
            object.foreground !== undefined && object.foreground !== null
                ? String(object.foreground)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.background !== undefined && (obj.background = message.background);
        message.foreground !== undefined && (obj.foreground = message.foreground);
        return obj;
    },
};
//# sourceMappingURL=decoration_color.js.map